"use client";
import "./question_answer_collapse.scss";
import { CollapsePanel } from "@/elements/collapse_panel/collapse_panel";
import { Icon } from "@/elements/icon/icon";
import { ReactElement, useState } from "react";
import { Spacer } from "@/elements/spacer/spacer";
import { Text } from "@/elements/text/text";
import classNames from "classnames";

interface Props {
  header: string;
  children: ReactElement;
}

export function QuestionAnswerCollapse({
  header,
  children,
}: Props): ReactElement {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={classNames("question-answer-collapse", {
        "question-answer-collapse--open": open,
      })}
    >
      <header
        className="question-answer-collapse__header"
        onClick={() => setOpen((open) => !open)}
      >
        <Text
          htmlElement="h3"
          type={open ? "h3-xbold" : "h3-regular"}
          color={open ? "inverted-pairings-default" : "neutral-on-surface"}
        >
          {header}
        </Text>
        <span className="question-answer-collapse__toggle">
          <Icon
            name="arrow-circle-down"
            size={24}
            tabletSize={42}
            color="accent-tinted"
          />
        </span>
      </header>
      <CollapsePanel open={open}>
        <Spacer size={24} />
        {children}
      </CollapsePanel>
    </div>
  );
}
